<div class="header_container">
  <div class="" [routerLink]="['/home']" style="cursor: pointer; margin-top: 10px;" aria-label="Go to Home">
    <img
      class=""
      ngSrc="assets/images/logo/LOGO RIA-01.svg"
      alt="Logo"
      width="130"
      height="50"
      priority
    />
  <!-- <div class="logo-text-container">
    <div class="ria-text">RIA</div>
    <div class="tagline-text">Evaluating impact and enhancing regulation</div>
  </div> -->
  </div>
  <nav class="navigation_container" aria-label="Primary">
    <a
      *ngFor="let link of navLinks"
      class="navigation_box"
      [routerLink]="link.route"
      [routerLinkActive]="'active_tab'"
      [routerLinkActiveOptions]="{ exact: (link.exact ?? false) }"
      (click)="closeMobileMenu()"
    >{{ link.label }}</a>
  </nav>

  <div class="user_info_container">
  <div class="timer_container">
    <app-timer></app-timer>
  </div>

  <button type="button" class="icon-button" (click)="toggleNotifications()" aria-label="Notifications" style="position: relative;">
      <img
        src="assets/icons/Notifications.svg"
        alt="Notifications"
        class="notification-icon"
        style="cursor: pointer"
      />
      <span *ngIf="notificationCount > 0"
        class="notif-badge clickable"
        [attr.aria-label]="'Unread notifications: ' + notificationCount"
      >
        {{ notificationCount }}
      </span>
  </button>

    <!-- Search Icon -->
  <button type="button" class="icon-button" (click)="toggleSearch()" aria-label="Search">
    <i class="pi pi-search search-icon"></i>
  </button>
  
  <div class="ellipsis-wrapper">
      <p-menu [model]="items" [popup]="true" #menu></p-menu>
      <button type="button" (click)="menu.toggle($event)" class="icon-button ellipsis-button" aria-label="Open menu">
        <i class="pi pi-ellipsis-v"></i>
      </button>
    </div>

    <!-- Hamburger for medium/small screens (right cluster) -->
    <button class="hamburger" type="button" [attr.aria-expanded]="mobileMenuOpen" aria-label="Open menu" (click)="toggleMobileMenu()">
      <span></span>
      <span></span>
      <span></span>
    </button>
  </div>
</div>

<!-- Mobile menu overlay -->
<div class="mobile-menu-overlay" *ngIf="mobileMenuOpen" (click)="toggleMobileMenu()" (keydown.enter)="toggleMobileMenu()" aria-label="Close menu overlay"></div>

<!-- Mobile slide-out menu -->
<dialog class="mobile-menu" [class.open]="mobileMenuOpen" [attr.open]="mobileMenuOpen ? '' : null" aria-label="Navigation menu" (keydown.escape)="toggleMobileMenu()">
  <div class="mobile-menu-header">
    <div class="user-meta">
  <span class="menu-name">{{ displayName }}</span>
  <div class="menu-meta"><span class="menu-role">{{ userRole }}</span></div>
    </div>
    <button type="button" aria-label="Close menu" (click)="toggleMobileMenu()">✕</button>
  </div>
  <nav class="mobile-nav" aria-label="Mobile Primary">
    <a *ngFor="let link of navLinks"
       [routerLink]="link.route"
       [routerLinkActive]="'active'"
       (click)="toggleMobileMenu()"
    >{{ link.label }}</a>
  </nav>

  <hr class="mobile-divider" />
  <div class="mobile-utilities">
    <a [routerLink]="['/profile-settings']" (click)="toggleMobileMenu()">Profile Settings</a>
    <button type="button" class="linkish help" (click)="onHelpClick(); toggleMobileMenu()">Help</button>
    <button type="button" class="linkish" (click)="logout(); toggleMobileMenu()">Logout</button>
  </div>
</dialog>

<!-- Search Popup -->
<app-search-popup
  *ngIf="showSearchPopup"
  [results]="searchResults"
  [isLoading]="isSearchLoading"
  [searchQuery]="searchQuery"
  [totalResults]="searchTotalResults"
  (closePopup)="handleSearchClose()"
  (resultClick)="handleSearchResultClick($event)"
  (searchChange)="handleSearchChange($event)"
></app-search-popup>

<!-- Notifiction Popup  -->
<app-notification-popup
  *ngIf="showNotificationPopup"
  class="notification-popup-container"
  [notifications]="notificationsList"
  [unreadCount]="notificationCount"
  (markRead)="onMarkRead($event)"
  (markAllRead)="onMarkAllRead()"
  (onClose)="handlePopupClose()"
></app-notification-popup>

<!-- Help PDF Preview Dialog -->
<p-dialog
  [header]="pdfFileName"
  [(visible)]="displayPdfViewer"
  [modal]="true"
  [style]="{ width: '70vw', height: '80vh' }"
  [draggable]="false"
  [resizable]="false"
  (onHide)="pdfUrl = null"
  styleClass="pdf-viewer-dialog"
>
  <ng-container *ngIf="safePdfUrl as sUrl">
    <iframe
      [src]="sUrl"
      style="width: 100%; height: calc(80vh - 4rem); border: none; background: #1e1e1e;"
      title="Help document preview"
    ></iframe>
  </ng-container>
  <ng-template pTemplate="footer"></ng-template>
</p-dialog>

<!-- Global session warning dialog -->
<app-session-warning-dialog></app-session-warning-dialog>

<!-- Support Contact Dialog redesigned -->
<p-dialog
  header="Contact Us"
  [(visible)]="showSupportDialog"
  [modal]="true"
  [dismissableMask]="true"
  [draggable]="false"
  [resizable]="false"
  styleClass="support-dialog"
  (onHide)="closeSupport()"
  [style]="{width: '420px'}"
>
  <div class="support-wrapper">
    <div class="support-intro left-align">
      <p class="support-text left-align">{{ supportMessage }}</p>
    </div>

    <div class="support-block" *ngFor="let se of supportEmails; let i = index">
      <span class="support-label" aria-hidden="true">{{ se.label }}</span>
      <div class="support-row" aria-label="Support email actions">
        <i class="pi pi-envelope email-icon" aria-hidden="true"></i>
        <span class="email-value" title="Support email">{{ se.email }}</span>
        <button type="button" pButton class="p-button-text p-button-sm support-action" (click)="copySupportEmail(se.email)" [attr.aria-label]="'Copy email ' + se.email">
          <i class="pi pi-copy"></i>
        </button>
        <button type="button" pButton class="p-button-text p-button-sm support-action" (click)="openMail(se.email)" [attr.aria-label]="'Compose email to ' + se.email">
          <i class="pi pi-send"></i>
        </button>
      </div>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <div class="support-footer">
      <button pButton type="button" label="Close" class="p-button-secondary" (click)="closeSupport()"></button>
    </div>
  </ng-template>
</p-dialog>
